// CourseLinkPicker
//
// Shown when a user opens GPS on a course that has no GolfAPI link yet (e.g. an
// old local/hand-entered course). Lists GolfAPI search matches so the user
// confirms which one this course is. The confirmed pick is persisted (the local
// course is tied to it) and flagged for TournyFlex staff review — so we never
// have to ask again.

export default function CourseLinkPicker({ courseName, candidates, onPick, onClose, busy }) {
  // GPS-capable matches first, then by closeness if a distance was returned.
  const sorted = [...(candidates || [])].sort((a, b) =>
    (b.has_gps - a.has_gps) || ((a.distance ?? 1e9) - (b.distance ?? 1e9)))

  return (
    <div style={overlay} onClick={busy ? undefined : onClose}>
      <div className="card" style={sheet} onClick={(e) => e.stopPropagation()}>
        <p style={{ fontWeight: 700, fontSize: '1.05rem', marginBottom: 2 }}>Match this course</p>
        <p className="text-muted text-sm" style={{ marginBottom: 14 }}>
          Which course is “{courseName}”? Pick the match to turn on GPS. We’ll remember it.
        </p>

        <div style={{ maxHeight: '50vh', overflowY: 'auto', margin: '0 -4px' }}>
          {sorted.map((c) => {
            const loc = [c.city, c.state].filter(Boolean).join(', ')
            return (
              <button
                key={c.external_course_id}
                onClick={() => !busy && c.has_gps && onPick(c)}
                disabled={busy || !c.has_gps}
                style={{
                  width: '100%', textAlign: 'left', padding: '10px 12px', marginBottom: 6,
                  border: '1px solid var(--green-mid)', borderRadius: 'var(--radius)',
                  background: 'var(--green-deep)', color: 'var(--cream)',
                  cursor: busy || !c.has_gps ? 'default' : 'pointer', opacity: c.has_gps ? 1 : 0.5,
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
                }}
              >
                <span style={{ minWidth: 0 }}>
                  <span style={{ display: 'block', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {c.course_name || c.club_name}
                  </span>
                  <span className="text-muted text-xs" style={{ display: 'block' }}>
                    {[c.club_name && c.club_name !== c.course_name ? c.club_name : null, loc, c.num_holes ? `${c.num_holes} holes` : null].filter(Boolean).join(' · ')}
                  </span>
                </span>
                <span style={{ flexShrink: 0, fontFamily: 'var(--font-mono)', fontSize: '0.6rem', color: c.has_gps ? 'var(--electric-green, #39FF14)' : 'var(--gray-600)' }}>
                  {c.has_gps ? 'GPS' : 'no GPS'}
                </span>
              </button>
            )
          })}
          {sorted.length === 0 && (
            <p className="text-muted text-sm" style={{ textAlign: 'center', padding: '12px 0' }}>No matches found.</p>
          )}
        </div>

        <button className="btn btn-ghost btn-full" onClick={onClose} disabled={busy} style={{ marginTop: 10 }}>
          {busy ? 'Loading…' : 'Cancel'}
        </button>
      </div>
    </div>
  )
}

const overlay = {
  position: 'fixed', inset: 0, zIndex: 1100, background: 'rgba(10,15,22,0.7)',
  display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
}
const sheet = {
  width: '100%', maxWidth: 480, margin: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0,
  paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
}
